import { render } from "./FounderView.vue?vue&type=template&id=3c4234eb&scoped=true"
import script from "./FounderView.vue?vue&type=script&lang=js"
export * from "./FounderView.vue?vue&type=script&lang=js"

import "./FounderView.vue?vue&type=style&index=0&id=3c4234eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4234eb"]])

export default __exports__